import * as React from 'react';
import { AccordionWrapper } from './AccordionWrapper';
import { TabWrapper } from './TabWrapper';
import { JSXElement } from '../OrderRender';
import { ELCLogger, TriggerType } from '@estee/elc-logging';

export enum displayTypes {
    accordion = 'accordion',
    tab = 'tab',
    default = 'default'
}

interface IWrappedConfig {
    label?: string;
    displayType?: displayTypes;
}

export interface IWrapperComponent {
    children: JSXElement;
    title?: string;
}

type IWrapper = {
    [key in displayTypes]?: React.FunctionComponent;
};

const wrappers: IWrapper = {
    [displayTypes.accordion]: AccordionWrapper,
    [displayTypes.tab]: TabWrapper
};

export const withWrapper = (
    wrappedComponent: JSXElement,
    config: IWrappedConfig,
    logger: ELCLogger
) => {
    if (!config.displayType) {
        return wrappedComponent;
    }

    const Wrapper = wrappers[config.displayType] as React.FunctionComponent<IWrapperComponent>;

    if (!Wrapper) {
        logger.error({
            triggerType: TriggerType.render,
            message: `${config.displayType} is not a valid display type.`
        });

        return wrappedComponent;
    }

    return <Wrapper title={config.label}>{wrappedComponent}</Wrapper>;
};
